export class SharedStrings {
}
SharedStrings.SUPPORT_EMAIL = 'help@colonist.io';
SharedStrings.DISCORD_CHANNEL = 'https://discord.gg/colonist';
SharedStrings.DISCORD_SERVER_ID = '605233308577562643';
SharedStrings.BLOG_URL = 'https://blog.colonist.io';
SharedStrings.APP_STORE_URL = 'https://apps.apple.com/us/app/colonist-io/id6444831129';
SharedStrings.PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.colonist.colonist';
